module.exports = __webpack_public_path__ + "img/birthday.fdbea582.svg";